import React, { useState,useRef,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({
  fontDark=true
}) => {
  const [menuState, setMenuState] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenDesk, setIsDropdownOpenDesk] = useState(false);
  const navigate = useNavigate()
  const clickCountRef = useRef(0);
  const dropdownRef = useRef();

const onClickService = (e) => {
    e.preventDefault();
    
      clickCountRef.current++;
      if (clickCountRef.current === 1) {
        setIsDropdownOpen(true);
      } 
      else if (clickCountRef.current === 2) {
        setMenuState(false)
        setIsDropdownOpen(false)
        navigate("/services");
        clickCountRef.current = 0;
      }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isDropdownOpenDesk) {
        if (!event.target.closest('.app')) {
          setIsDropdownOpenDesk(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownOpenDesk]);

  const menuClick = () => {
    setMenuState((prev) => !prev);
  };

  return (
    <>
      
      <div className={`header`}>
        <div className="header-wrapper container">
          <nav className="navbar d-md-flex flex-md-row d-block">
            <nav className="navbar-container py-2">
              <div className="nav-elements d-flex justify-content-between align-items-center px-lg-2">
                <input className="d-none" type="checkbox" id="menu-toggle" />
                <img alt="logo" loading="lazy" src="/images/icons/nav-logo-new.png" className="nav-logo " onClick={()=>{navigate("/home")}}/>
                <nav className="">
                  <ul
                    className="nav-list d-lg-flex gap-5 align-items-center d-none main-nav w-100 justify-content-between pt-0 ps-0"
                    id="js-menu"
                  >
                    <li>
                      <Link to={"/elastron-fabric"} className={`nav-links ${fontDark && "color-dark"}`}>
                        Elastron Fabric
                      </Link>
                    </li>
                    <li>
                      <Link to={"/3m-di-noc"} className={`nav-links ${fontDark && "color-dark"}`}>
                        3M Di-NOC
                      </Link>
                    </li>
                    
                    <li>
                      <Link to={"/3d-decorative-walls"} className={`nav-links ${fontDark && "color-dark"}`}>
                      3D Decorative Walls
                      </Link>
                    </li>
                    <li>
                      <Link to={"/partnership-opportunities"} className={`nav-links ${fontDark && "color-dark"}`}>
                      Partnership
                      </Link>
                    </li>
                  <li>
                      <Link to={"/contact"} className={`nav-links ${fontDark && "color-dark"}`}>
                      Contact
                      </Link>
                    </li>

                    {/* <div className="navigation-dropdown" ref={dropdownRef}>
                    <li onMouseEnter={()=>{setIsDropdownOpenDesk(true)}} >

                        <div className="dropdown-trigger d-flex align-items-center">
                            <Link to={"/services"} className="nav-links" onClick={()=>{setIsDropdownOpenDesk(false)}}>CONSULTATION SERVICES</Link>
                            <img alt="icon" loading="lazy" src='/images/icons/dropDown.png' className={isDropdownOpenDesk ? "rotate-icon arrow-icon":"rotate-back arrow-icon" }/>
                        </div>
                        <div className={`dropdown-content ${isDropdownOpenDesk ? 'open' : 'none-delay'}`} onMouseEnter={()=>{setIsDropdownOpenDesk(true)}} onMouseLeave={()=>{setIsDropdownOpenDesk(false)}}>
                
                          <Link to={"/home"} className="nav-links" onClick={()=>{setIsDropdownOpenDesk(false)}}>
                            <p className="mb-0">HOME</p>
                          </Link>
                          <Link to={"/about"} className="nav-links" onClick={()=>{setIsDropdownOpenDesk(false)}}>
                            <p className="mb-0">ABOUT</p>
                          </Link>
                        </div>
                      </li>
                      </div> */}
                     

                    
                
                   
                  </ul>
                </nav>

                <label
                  value="menu-toggle"
                  onClick={menuClick}
                  className="responsive-menu-btn d-lg-none d-inline"
                >
                  <img loading="lazy"
                    src="/images/icons/icons8-hamburger-menu-50.png"
                    className="img-fluid menu-btn"
                    alt="menu"
                    style={{filter:"invert(1)"}}
                  />
                </label>

                <div className="nav-buttton ml-5 d-lg-flex d-none gap-4 extras-btns">
                  <button className="genral-btn-light" 
                  onClick={()=>{navigate("/contact")}}
                  >
                   Get a Quote
                  </button>
                </div>
              </div>
            </nav>

            {/* Dropdown in responsive mode */}
            <nav className="responsive-popup-menu w-100">
              <div className="py-3 d-lg-none" style={{ display: menuState ? "block" : "none" }}>
              <ul
                className="resp-nav-list d-lg-none w-100 gap-4 hs-dropdown [--trigger:hover] pl-4"
                style={{ display: menuState ? "block" : "none" }}
              >
                <li>
                  <Link to={"/elastron-fabric"} className="nav-links">
                    Elastron Fabric
                  </Link>
                </li>
                <li>
                  <Link to={"/3m-di-noc"} className="nav-links">
                    3M Di-NOC
                  </Link>
                </li>
                {/* <li>
                  <div className="navigation-dropdown">
                    <div className="dropdown-trigger d-flex align-items-center" style={{color:"black"}} onClick={onClickService} >
                        <a className="nav-links" >CONSULTATION SERVICES</a>
                        <img alt="icon" loading="lazy" src='/images/icons/dropDown.png' className={isDropdownOpen ? "rotate-icon arrow-icon":"rotate-back arrow-icon" } />
                    </div>
                    <div className={`dropdown-content ${isDropdownOpen ? 'open' : 'd-none'}`} style={{top:"85%",left:"0%"}}>
                      
                      <Link to={"/home"} className="nav-links" onClick={()=>{setIsDropdownOpen(false); setMenuState(false)}}>
                        <p className="mb-0">HOME</p>
                      </Link>
                      <Link to={"/about"} className="nav-links" onClick={()=>{setIsDropdownOpen(false); setMenuState(false)}}>
                        <p className="mb-0">ABOUT</p>
                      </Link>
                    </div>
                  </div>
                  </li> */}
                <li>
                  <Link to={"/3d-decorative-walls"} className="nav-links">
                    3D Decorative Walls
                  </Link>
                </li>
                <li>
                  <Link to={"/partnership-opportunities"} className="nav-links">
                    
                      Partnership
                  </Link>
                </li>
                
                <li>
                  <Link to={"/contact"} className="nav-links">
                    Contact
                  </Link>
                </li>
               
              </ul>
              <div className="nav-buttton flex-wrap d-flex gap-4 extras-btns">
                <button className="genral-btn-light" 
                onClick={()=>{navigate("/contact")}}
                >
                  Get a Quote
                </button>
              </div>
              </div>
            </nav>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header; 